/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {ReaderInstance} from "../models/reader-instance";
import {ReaderService} from "../services/reader.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";

@Injectable()
@Input()
export class ReaderInstancesResolver implements Resolve<ReaderInstance[]> {

  constructor(
    private mReaderService: ReaderService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<ReaderInstance[]> {
    try {
      return await this.mReaderService.getAllReaderInstances();
    } catch (error) {
      console.error("Problem resolving Reader Instances... Error: " + error, error);
    }
  }

}
